import { render, staticRenderFns } from "./ImagePreview.vue?vue&type=template&id=61d58dca&scoped=true"
import script from "./ImagePreview.vue?vue&type=script&lang=js"
export * from "./ImagePreview.vue?vue&type=script&lang=js"
import style0 from "./ImagePreview.vue?vue&type=style&index=0&id=61d58dca&prod&lang=less&scoped=true"
import style1 from "./ImagePreview.vue?vue&type=style&index=1&id=61d58dca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d58dca",
  null
  
)

export default component.exports